module.exports = __webpack_public_path__ + "img/hero-bg.27201d7b.png";